// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18wgV","col":"styles_col__B5Vji","actions":"styles_actions__3G4bX","conflict":"styles_conflict__1_CqN"};